module.exports = __webpack_public_path__ + "static/media/_ethiopia.6c1bd7db.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/_ethiopia.svg
// module id = 2319
// module chunks = 7